import useLadyService from '@/services/LadyService';
import { setActivateProfileStatus } from '@/stores/slices/popupSlice';
import { getProfileStatus } from '@/stores/slices/userProfileSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useMemo, useCallback } from 'react';

const TopLinksTabsObj = () => {
	const { t, userBalance, lang } = useLadyService();
	const profileStatus = useSelector(getProfileStatus);
	const dispatch = useDispatch()

	const wallet = useMemo(() => {
		return {
			id: 10,
			name: t('balance'),
			href: `${lang}/lk/balance`,
			wallet: userBalance,
		};
	}, [t, lang, userBalance]);

	const handleActivateProfile = useCallback(() => {
		dispatch(setActivateProfileStatus(true));
	}, [dispatch]);

	const allTabs = useMemo(() => {
		return {
			default: [
				{ id: 1, name: t('about'), href: `/about`, count: 0 },
				{ id: 2, name: t('guide'), href: `/guide`, count: 0 },
				{ id: 3, name: t('support'), href: `/lk/support`, count: 0 },
			],
			photograph: [
				{ id: 1, name: t('profuser'), href: '#', count: 0 },
				{ id: 2, name: t('photo'), href: '#', count: 0 },
				{ id: 3, name: t('videofotograph'), href: '#', count: 0 },
				{ id: 4, name: t('interior'), href: '#', count: 0 },
				{ id: 5, name: t('reviews'), href: '/lk/reviews', count: 0 },
			],
			customer: [
				{ id: 1, name: t('profuser'), href: `/lk/customer` },
				{
					id: 2,
					name: t('subandfilters'),
					href: `/lk/customer/subscriptions`,
					count: 0,
				},
				{ id: 3, name: t('history'), href: `/history`, count: 0 },
				wallet,
			],
			agency: [
				{ id: 1, name: t('profuser'), href: `/lk/agency` },
				{
					id: 2,
					name: t('myads'),
					href: `/lk/profiles`,
					count: 0,
					disabled: !profileStatus,
					onClick: profileStatus ? null : handleActivateProfile,
				},
				{ id: 3, name: t('reviews'), href: `/lk/reviews`, count: 0 },
				{ id: 4, name: t('myoperator'), href: `/lk/operators` },
				{ id: 5, name: t('myparty'), href: `/lk/parties` },
				{ id: 6, name: t('mystat'), href: `/lk/statistic` },
				wallet,
			],
			indi: [
				{ id: 1, name: t('profuser'), href: '/lk/indi' },
				{
					id: 2,
					name: t('myads'),
					href: '/lk/profiles',
					count: 0,
					disabled: !profileStatus,
					onClick: profileStatus ? null : handleActivateProfile,
				},
				{ id: 3, name: t('reviews'), href: '/lk/reviews', count: 0 },
				{ id: 4, name: t('mystat'), href: '/lk/statistic' },
				wallet,
				{ id: 5, name: t('videochat'), href: `/lk/videochats` },
				{ id: 6, name: t('myorder'), href: `/lk/reservations` },
			],
			indi_lk: [
				{ id: 1, name: t('profuser'), href: '/lk/indi' },
				{
					id: 2,
					name: t('myads'),
					href: '/lk/profiles',
					disabled: !profileStatus,
					onClick: profileStatus ? null : handleActivateProfile,
				},
				{ id: 3, name: t('reviews'), href: '/lk/reviews' },
				{ id: 4, name: t('mystat'), href: '/lk/statistic' },
				wallet,
				{ id: 5, name: t('videochat'), href: `/lk/videochats` },
				{ id: 6, name: t('myorder'), href: `/lk/reservations` },
			],
			admin_lk: [
				{ id: 1, name: t('profuser'), href: '/lk/indi' },
				{ id: 2, name: t('myads'), href: '/lk/profiles' },
				wallet,
			],
		};
	}, [profileStatus, handleActivateProfile, t, wallet]);

	return allTabs;
};

export default TopLinksTabsObj;
